import { render, staticRenderFns } from "./InterScheme.vue?vue&type=template&id=48438674&"
import script from "./InterScheme.vue?vue&type=script&lang=js&"
export * from "./InterScheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports